$(function () {
    const $form = $('[data-stock-action-form]');
    if (!$form.length || !['commissioning', 'status-change', 'sale', 'write-off', 'recognition'].includes($form.data('operation'))) return;

    const $balance = $form.find('[data-stock-balance]');
    const $group = $form.find('[data-stock-units-group]');
    const $select = $group.find('[data-stock-units]');
    const $list = $group.find('[data-unit-list]');
    const $search = $group.find('[data-unit-search]');
    const $count = $group.find('[data-unit-selected-count]');
    const $fixedDetails = $form.find('[data-fixed-unit-details]');
    const $modal = $('[data-unit-history-modal]');
    const $history = $modal.find('[data-unit-history-content]');
    const single = $form.data('operation') === 'recognition';
    const $quantity = $form.find('[name="quantity"]');
    const $submit = $form.find('button[type="submit"], button:not([type])').first();
    const gateSubmit = ['commissioning', 'status-change'].includes($form.data('operation'));
    let units = [];
    let historyRequestId = 0;
    let searchQuery = '';
    let selectionError = '';
    let pickerDisabledSubmit = false;

    const groupNames = { recognized: 'Уже учтена', unrecognized: 'Ещё не учтена', zero: 'Подтверждённый ноль', unknown: 'Неизвестна' };
    const money = kopecks => (kopecks / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽';
    const date = value => value ? new Date(value.slice(0, 10) + 'T00:00:00').toLocaleDateString('ru-RU') : '—';

    function validateSelection() {
        if (single || !$group.is(':visible')) {
            selectionError = '';
            $group.find('[data-unit-group-warning]').remove();
            if (pickerDisabledSubmit) $submit.prop('disabled', false);
            pickerDisabledSubmit = false;
            return;
        }
        const selected = $select.val() || [];
        const chosenIds = new Set(selected.map(String));
        const names = [...new Set(units.filter(unit => chosenIds.has(String(unit.id))).map(unit => unit.recognition_group || 'unproven'))];
        selectionError = names.length > 1 ? 'Выбраны экземпляры из разных групп учёта стоимости. Для этого действия проведите каждую группу отдельно.' : '';
        $group.find('[data-unit-group-warning]').remove();
        if (selectionError) $('<div/>', { class: 'alert alert-warning mt-2', 'data-unit-group-warning': '', role: 'alert' }).text(selectionError).appendTo($group);
        if (gateSubmit) {
            pickerDisabledSubmit = !!selectionError || !selected.length;
            $submit.prop('disabled', pickerDisabledSubmit);
        }
    }

    function unitRow(unit, selected, fixed = false) {
        const $row = $('<div/>', { class: 'stock-transfer-unit', 'data-search': [unit.serial_number, unit.inventory_number, unit.id].filter(Boolean).join(' ').toLowerCase() });
        const $main = $('<div/>', { class: 'd-flex align-items-start' });
        let $label = $('<label/>', { class: 'flex-grow-1' });
        if (!fixed) {
            const id = 'action-unit-' + unit.id;
            const $input = $('<input/>', { type: single ? 'radio' : 'checkbox', id, value: unit.id, class: 'mr-2', 'data-unit-choice': '' }).prop('checked', selected);
            if (single) $input.attr('name', 'unit_selection_display');
            $label.attr('for', id);
            $main.append($input);
        } else {
            $label = $('<div/>', { class: 'flex-grow-1' });
        }
        const numbers = [unit.serial_number && 'Серийный № ' + unit.serial_number, unit.inventory_number && 'Инвентарный № ' + unit.inventory_number].filter(Boolean);
        $('<strong/>').text(numbers.join(' · ') || 'Без серийного и инвентарного номеров').appendTo($label);
        if (!numbers.length) {
            $('<span/>', { class: 'text-muted small ml-2' }).text('Внутр. #' + unit.id).appendTo($label);
            if (fixed) $('<div/>', { class: 'small text-warning' }).text('Внутренний номер обозначает учётную запись, а не подтверждает физическую идентичность.').appendTo($label);
        }
        const known = unit.cost_state !== 'unknown' && unit.valuation_status === 'confirmed';
        const facts = [
            'Состояние: ' + unit.status_label,
            'Добавлено: ' + date(unit.received_at),
            'Партия #' + unit.lot_id,
            'Стоимость: ' + (known ? money(unit.original_cost_kopecks) : 'неизвестна или требует проверки'),
            'Учтено: ' + (known ? money(unit.recognized_cost_kopecks) : '—'),
            'Ещё не учтено: ' + (known ? money(unit.unrecognized_cost_kopecks) : '—'),
            'Группа: ' + (groupNames[unit.recognition_group] || 'Требуется сверка'),
            'Гарантия: ' + date(unit.warranty_until),
        ];
        if (unit.maintenance_count) facts.push('Обслуживаний: ' + unit.maintenance_count);
        if (unit.include_in_contract_inventory) facts.push('В описи договора');
        $('<div/>', { class: 'small text-muted mt-1' }).text(facts.join(' · ')).appendTo($label);
        $main.append($label);
        $row.append($main);
        $('<button/>', { type: 'button', class: 'btn btn-link btn-sm p-0 mt-1 mr-3', 'data-history-url': unit.history_url, text: 'История' }).appendTo($row);
        $('<a/>', { href: unit.source_url, class: 'small', text: 'Карточка экземпляра', target: '_blank', rel: 'noopener noreferrer' }).appendTo($row);
        return $row;
    }

    function render() {
        const $chosen = $balance.find(':selected');
        const eligibleIds = single ? new Set($select.find('option').map(function () { return $(this).val(); }).get()) : null;
        const matching = units.filter(unit => unit.item_id === Number($chosen.data('item-id')) && unit.status === $chosen.data('status')
            && (!eligibleIds || eligibleIds.has(String(unit.id))));
        $list.empty();
        $search.val(searchQuery);
        if (!$group.is(':visible') || !matching.length) {
            $count.text('');
            validateSelection();
            return;
        }
        const selected = $select.val() || [];
        const ids = new Set((Array.isArray(selected) ? selected : [selected]).filter(Boolean).map(String));
        matching.forEach(unit => {
            const $row = unitRow(unit, ids.has(String(unit.id)));
            $row.toggle(!searchQuery || $row.attr('data-search').includes(searchQuery));
            $list.append($row);
        });
        $count.text(single ? 'Выбран: ' + ids.size : 'Выбрано: ' + ids.size);
        validateSelection();
    }

    $form.on('stock:balances-cleared', function () {
        units = [];
        searchQuery = '';
        $list.empty();
        $fixedDetails.empty();
        validateSelection();
    });
    $form.on('stock:balances-loaded', function (_, loadedUnits) {
        units = loadedUnits;
        render();
        if ($fixedDetails.length) {
            const unit = units.find(entry => entry.id === Number($fixedDetails.data('unit-id')));
            if (unit) {
                $fixedDetails.empty().append(unitRow(unit, true, true));
                if (single) {
                    $group.hide();
                    $list.empty();
                }
            }
        }
    });
    $balance.on('change', function () { searchQuery = ''; render(); });
    $select.on('change', render);
    $list.on('change', '[data-unit-choice]', function () {
        const selected = $list.find('[data-unit-choice]:checked').map(function () { return $(this).val(); }).get();
        $select.val(single ? (selected[0] || '') : selected).trigger('change');
    });
    $form.on('submit', function (event) {
        if (selectionError || (!single && $group.is(':visible') && !($select.val() || []).length)) {
            event.preventDefault();
            if (selectionError) $group.find('[data-unit-group-warning]').get(0)?.scrollIntoView({ block: 'center' });
            else $search.trigger('focus');
        }
    });
    $search.on('input', function () {
        searchQuery = $(this).val().trim().toLowerCase();
        $list.children().each(function () { $(this).toggle(!searchQuery || $(this).attr('data-search').includes(searchQuery)); });
    });

    function renderHistory(entries) {
        if (!entries.length) return $('<p/>').text('Записей пока нет.');
        const $entries = $('<ul/>', { class: 'list-unstyled mb-0' });
        entries.forEach(entry => {
            const $entry = $('<li/>', { class: 'mb-2 pb-2 border-bottom' });
            $('<strong/>').text((entry.date || '—') + ' · ' + entry.label).appendTo($entry);
            $('<div/>').text(entry.description || '').appendTo($entry);
            if (entry.comment) $('<div/>', { class: 'small text-muted' }).text(entry.comment).appendTo($entry);
            $entries.append($entry);
        });
        return $entries;
    }
    $form.on('click', '[data-history-url]', function () {
        const request = ++historyRequestId;
        $history.text('Загрузка истории…');
        $modal.modal('show');
        $.getJSON($(this).attr('data-history-url')).done(response => {
            if (request !== historyRequestId) return;
            $history.empty().append($('<h6/>').text('Последние два перемещения'), renderHistory(response.data.recent_transfers));
            const $more = $('<button/>', { type: 'button', class: 'btn btn-link p-0 mt-2', text: 'Вся история' });
            $more.on('click', function () {
                $history.empty().append($('<h6/>').text('Вся история'), renderHistory(response.data.history));
            });
            $history.append($more);
        }).fail(() => { if (request === historyRequestId) $history.text('Не удалось загрузить историю. Попробуйте ещё раз.'); });
    });
    $modal.on('hidden.bs.modal', function () { historyRequestId++; });
});
